<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      theme: 'moonLightWhite'
    }
  },
  created(){
    this.$store.watch((state, getters) => {
      if(state.user.theme){
        this.theme = state.user.theme
      }
      // this.theme = this.$store.state.user.theme
      // console.log('app-theme', theme)
      document.getElementById("style").setAttribute("href","/static/css/"+this.theme+"/index.css");
    })
    
  }
}
</script>